import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'
import { CopyFunction, Content, Step } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const { CONTENT, CONFIG_WITH_FAMILY_AND_ELIGIBILITY } = USA
const { WELCOME, REGISTRATION, FAMILY, SUMMARY, ELIGIBILITY } = CONTENT

const partnerName = 'Home State Health'
const planName = 'Home State Health, your MO HealthNet Managed Care Health Plan'

const welcomeContent: Step = {
  ...WELCOME.enUS,
  copy: (WELCOME.enUS.copy as CopyFunction)(planName),
}

const content: Content = {
  'en-US': {
    steps: [
      welcomeContent,
      REGISTRATION.enUS,
      FAMILY.enUS,
      ELIGIBILITY.enUS,
      SUMMARY.enUS,
    ],
    footerLinks: FOOTERLINKS.USA,
  },
}

export const baseConfig: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...CONFIG_WITH_FAMILY_AND_ELIGIBILITY,
    id: 'home-state-health',
    productConfigAppName: 'home-state-health',
    name: partnerName,
    codes: {
      membership: 'HOMESTATEHEALTH',
    },
    partnerUrlSlug: 'hsh',
  },
  content,
}

export const baseConfigWithDnaV2Design: PartnerConfig = {
  ...baseConfig,
  config: {
    ...baseConfig.config,
    useDnaV2Design: true,
  },
}

export default [baseConfig, baseConfigWithDnaV2Design]
